import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ExhibitionsPage from './pages/Exhibitions';
import ExhibitionDetailPage from './pages/ExhibitionDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivateEventsPage from './pages/PrivateEventsPage';
import ArtAdvisoryPage from './pages/ArtAdvisoryPage';
import ArtistsPage from './pages/ArtistsPage';
import ArtistDetailPage from './pages/ArtistDetailPage';
import WorkDetailPage from './pages/WorkDetailPage';
import JournalPage from './pages/JournalPage';
import PostDetailPage from './pages/PostDetailPage';
import { LanguageProvider } from './lib/LanguageContext';

function App() {
  return (
    <div className="App bg-bone text-charcoal">
      <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/exhibitions" element={<ExhibitionsPage />} />
          <Route path="/exhibitions/:id" element={<ExhibitionDetailPage />} />
          <Route path="/artists" element={<ArtistsPage />} />
          <Route path="/artists/:id" element={<ArtistDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/art-advisory" element={<ArtAdvisoryPage />} />
          <Route path="/private-events" element={<PrivateEventsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/journal" element={<JournalPage />} />
          <Route path="/journal/:slug" element={<PostDetailPage />} />
          <Route path="/:id" element={<WorkDetailPage />} />
        </Routes>
      </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
